import moment from 'moment';

// Day must be a moment object
const checkIsCalendarDayBlocked = ({ day, bookings }) => {
  if (day.isBefore(moment().format('MM-DD-YYYY'))) {
    return true;
  }
  let is_blocked = false;
  bookings.forEach(booking => {
    if (
      day.isBetween(
        moment(booking.table.start_date, 'YYYY-MM-DD'),
        moment(booking.table.end_date, 'YYYY-MM-DD')
      ) ||
      day.isSame(booking.table.start_date)
    ) {
      is_blocked = true;
    }
  });

  const containsStartDate = bookings.some(booking =>
    day.isSame(booking.table.start_date, 'day')
  );
  const containsEndDate = bookings.some(booking =>
    day.isSame(booking.table.end_date, 'day')
  );

  const isHalfDayStart = containsStartDate && !containsEndDate;
  const isHalfDayEnd = !containsStartDate && containsEndDate;

  if (isHalfDayStart || isHalfDayEnd) return false;

  return is_blocked;
};

export default checkIsCalendarDayBlocked;
